import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=6d98cd42&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=6d98cd42&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d98cd42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d98cd42')) {
      api.createRecord('6d98cd42', component.options)
    } else {
      api.reload('6d98cd42', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=6d98cd42&scoped=true", function () {
      api.rerender('6d98cd42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/five/instrument/basicSkillsTest/Main.vue"
export default component.exports